import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useMe } from '../api/hooks';
import { de } from '../i18n/de';
import { safeNext } from '../lib/nextPath';

function Status({ text, error }: { text: string; error?: boolean }) {
  return <div className={`page ${error ? 'error-text' : 'muted'}`}>{text}</div>;
}

/** Bereich der App (Übersicht, Geschichten, Profil): nur angemeldet – sonst zur Anmeldung und danach wieder hierher. */
export function RequireAuth() {
  const { data: me, isLoading, error } = useMe();
  const location = useLocation();
  if (isLoading) return <Status text={de.common.loading} />;
  if (error) return <Status text={de.errors.network} error />;
  if (!me) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  return <Outlet />;
}

/** Anmeldung und Registrierung: Wer angemeldet ist (auch gerade eben), kommt in die App – dorthin, wo er hinwollte. */
export function PublicOnly({ children }: { children: ReactNode }) {
  const { data: me, isLoading } = useMe();
  const [params] = useSearchParams();
  if (isLoading) return <Status text={de.common.loading} />;
  if (me) return <Navigate to={safeNext(params.get('next'))} replace />;
  return <>{children}</>;
}
